interface IApiVersionRange {
  min?: number;
  max?: number;
}

export const isApiVersionInRange = (
  apiVersion: string | undefined,
  { min, max }: IApiVersionRange
): boolean => {
  const majorVersion = parseInt(apiVersion ?? '', 10);

  if (Number.isNaN(majorVersion)) {
    return true;
  }
  if (min !== undefined && majorVersion < min) {
    return false;
  }
  if (max !== undefined && majorVersion > max) {
    return false;
  }
  return true;
};
